import React, { useState, useEffect, useContext } from "react";
import "../common/custom_css.css";
import AuthContext from "../common/AuthContext";
import { API } from "../common/api-service";
import { Link, useHistory } from "react-router-dom";
import { commonFunction } from "../common/common-functions";
import ArticleIcon from "@mui/icons-material/Article";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";

export default function Candidates() {
  const history = useHistory();
  const { authState } = useContext(AuthContext);
  const token = authState.token.slice(1, -1);

  const renderTags = (tag) => {
    return (
      <button className="btn btn-secondary btn-xs tags-margin" key={tag.text}>
        {tag.text}
      </button>
    );
  };

  const deleteRow = (id) => {
    if (window.confirm("Are you sure you wish to delete this item?"))
      API.updateItem("candidate_active", id, { active: false }, token)
        .then((resp) => {
          API.getItems("candidates/", token)
            .then((resp2) => {
              const rows = createRowsList(resp2, columns);
              setState({
                ...state,
                columns: columns,
                rows: rows,
              });
            })
            .catch((error) => console.log(error));
          history.push("/candidates/");
        })
        .catch((error) => console.log(error));
  };

  const activeRow = (id) => {
    if (window.confirm("Are you sure you wish to active this item?"))
      API.updateItem("candidate_active", id, { active: true }, token)
        .then((resp) => {
          API.getItems("candidates/", token)
            .then((resp2) => {
              const rows = createRowsList(resp2, columns);
              setState({
                ...state,
                columns: columns,
                rows: rows,
              });
            })
            .catch((error) => console.log(error));
          history.push("/candidates/");
        })
        .catch((error) => console.log(error));
  };

  const columns = React.useMemo(
    () => [
      {
        field: "actions",
        type: "actions",
        headerName: "Actions",
        width: 150,
        cellClassName: "actions",
        getActions: (params) => {
          if ((params.row.active === "✔")) {
            return [
              <GridActionsCellItem
                icon={<ArticleIcon />}
                label="Detail"
                className="textPrimary"
                component={Link}
                to={{
                  pathname: `/candidates/detail/`,
                  state: { id: params.id },
                }}
                color="inherit"
              />,
              <GridActionsCellItem
                icon={<EditIcon />}
                label="Edit"
                className="textPrimary"
                component={Link}
                to={{
                  pathname: `/candidates/create/`,
                  state: { id: params.id },
                }}
                color="inherit"
              />,
              <GridActionsCellItem
                icon={<DeleteIcon />}
                label="Delete"
                onClick={() => deleteRow(params.id)}
                color="inherit"
              />,
            ];
          } else {
            return [
              <GridActionsCellItem
                icon={<ArticleIcon />}
                label="Detail"
                className="textPrimary"
                component={Link}
                to={{
                  pathname: `/candidates/detail/`,
                  state: { id: params.id },
                }}
                color="inherit"
              />,
              <GridActionsCellItem
                icon={<EditIcon />}
                label="Edit"
                className="textPrimary"
                component={Link}
                to={{
                  pathname: `/candidates/create/`,
                  state: { id: params.id },
                }}
                color="inherit"
              />,
              <GridActionsCellItem
                icon={<AddIcon />}
                label="Add"
                onClick={() => activeRow(params.id)}
                color="inherit"
              />,
            ];
          }
        },
      },
      { field: "id", headerName: "ID", width: 50 },
      { field: "name", headerName: "Name", width: 200 },
      {
        field: "location",
        headerName: "Location",
        width: 180,
        renderCell: (cellValues) => {
          var tags = cellValues.row.location;
          if (tags && tags.length != 0) {
            return (
              <>
                {tags &&
                  tags.map((tag, i) => {
                    return renderTags(tag);
                  })}
              </>
            );
          } else {
            return <></>;
          }
        },
      },
      { field: "current_position", headerName: "Current Position", width: 100 },
      { field: "dob", headerName: "Date of birth", width: 100 },
      { field: "mobile", headerName: "Mobile", width: 100 },
      { field: "email", headerName: "Email", width: 150 },
      { field: "active", headerName: "Is active?", width: 100 },
    ],
    [deleteRow, activeRow]
  );

  const initialState = {
    columns: [],
    rows: [],
  };

  const [state, setState] = useState(initialState);

  function createRowsList(rows, cols) {
    let validrows = [];
    rows &&
      rows.forEach((row) => {
        let validrow = {};
        cols &&
          cols.forEach((col) => {
            switch (col.field) {
              case "location":
                if (row[col.field]) {
                  var tags = commonFunction.splitStrToTags(row[col.field]);
                  validrow[col.field] = tags;
                } else {
                  validrow[col.field] = [];
                }
                break;
              case "active":
                if (row[col.field]) {
                  validrow[col.field] = "✔";
                } else {
                  validrow[col.field] = "×";
                }
                break;
              //   case "gender":
              //     if (row[col.field] === "M") {
              //       validrow[col.field] = "Male";
              //     } else {
              //       validrow[col.field] = "Female";
              //     }
              //     break;
              default:
                validrow[col.field] = row[col.field];
                validrow["id"] = row["id"];
            }
          });
        validrows.push(validrow);
      });
    return validrows;
  }

  const newRow = () => {
    history.push({
      pathname: "/candidates/create/",
    });
  };

  useEffect(() => {
    API.getItems("candidates_list", token)
      .then((resp) => {
        const rows = createRowsList(resp, columns);
        setState({
          ...state,
          columns: columns,
          rows: rows,
        });
      })
      .catch((error) => console.log(error));
  }, []);

  return (
    <React.Fragment>
      <div className="content-wrapper">
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1>Candidates</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="#">Home</a>
                  </li>
                  <li className="breadcrumb-item active">Candidates</li>
                </ol>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </section>
        {/* Main content */}
        <section className="content">
          <div className="card card-default">
            {/* <div className="col-sm-6" style={selectStore}>
                <StoreSelection />
              </div> */}
            <div className="card-body">
              <div className="toolbar row ustorekit-common-under-margin-10">
                <div className="col-md-2">
                  <button
                    className="cell-button btn btn-success"
                    onClick={newRow}
                  >
                    Add a Candidate
                  </button>
                </div>
              </div>
              <div className="relativeWrapper">
                <div className="absoluteWrapper"></div>
                <DataGrid rows={state.rows} columns={columns} />
              </div>
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
}
